export const DATE_TIME_FORMAT = 'MMMM Do, YYYY @ h:mma';
export const DATE_FORMAT = 'MMMM Do, YYYY';
export const SHORT_DATE_FORMAT = 'DD/MM/YYYY';
export const TIME_FORMAT = 'h:mm a';